import { useQuery } from "@tanstack/react-query";
import { Member } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { memberQueryKeys } from "./keys";


const getData = async (agentId: number) => {
    const res = await memberRepository.find(agentId);
    return res.data?.data;
};

export const useMembers = (agentId: number) => {
    return useQuery<Member[]>({
        queryKey: memberQueryKeys.all(agentId),
        queryFn: async () => getData(agentId),
        retry: false
    });
};
